<template>
    <div>
        <b-card-header v-b-toggle.access-code-1>
            STEP 1 - Obtain Access Token - <u><b>{{ accessTokenUrl }}</b></u> <br/> <b v-if="accessResponse">Access Token Obtained</b>
        </b-card-header>
        <b-collapse id="access-code-1">
            <b-card>
                <b-row>
                    <b-col cols="6">
                        <b-form-group>
                            <label>Client ID (required)</label>
                            <b-form-input 
                                v-model="client.uuid" 
                                placeholder="Enter Client ID"
                                @change="(e)=> validate('client','uuid', e)">
                            </b-form-input>
                            <b-form-invalid-feedback :state="validation.client.uuid">Client ID Required.</b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>  
                    <b-col cols="6">
                        <b-form-group>
                            <label>Client Secret (required)</label>
                            <b-form-input v-model="client.secret" placeholder="Enter Client Secret" @change="(e)=> validate('client','secret', e)">
                            </b-form-input>
                            <b-form-invalid-feedback :state="validation.client.secret">Client Secret Required.</b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>  
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <b-form-group>
                            <label>First Name (required)</label>
                            <b-form-input v-model="agent.firstName" placeholder="Enter Agent's First Name" @change="(e)=> validate('agent','firstName', e)"></b-form-input>
                            <b-form-invalid-feedback :state="validation.agent.firstName">First Name Required.</b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group>
                            <label>Last Name (required)</label>
                            <b-form-input v-model="agent.lastName" placeholder="Enter Agent's Last Name" @change="(e)=> validate('agent','lastName', e)"></b-form-input>
                            <b-form-invalid-feedback :state="validation.agent.lastName">Last Name Required.</b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="6">
                        <b-form-group>
                            <label>Email (required)</label>
                            <b-form-input v-model="agent.email" placeholder="Enter Agent's Email Address" @change="(e)=> validate('agent','email', e)"></b-form-input>
                            <b-form-invalid-feedback :state="validation.agent.email">Email Address Required.</b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group>
                            <label>Phone (optional)</label>
                            <b-form-input v-model="agent.phone" placeholder="Enter Agent's Phone Number"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <b-form-group>
                            <label>License ID (required)</label>
                            <b-form-input v-model="agent.licenseId" placeholder="Enter Agent's License ID" @change="(e)=> validate('agent','licenseId', e)"></b-form-input>
                            <b-form-invalid-feedback :state="validation.agent.licenseId">License ID Required.</b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group>
                            <label>License State (required)</label>
                            <custom-select
                                v-if="stateOptions.length > 0"
                                :reduce="option => option.value"
                                v-model="agent.licenseState"
                                :options="stateOptions"
                                :clearable="false"
                                required
                                cs-label="text"
                                unique-identifier="value"
                                aria-placeholder="Select Agent's License State"
                                @input="(e)=> validate('agent','licenseState', e)"
                            />
                            <b-form-invalid-feedback :state="validation.agent.licenseState">License State Required.</b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <b-form-group>
                            <label>Broker Company</label>
                            <b-form-input v-model="agent.broker" placeholder="Enter Broker Company Name"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group>
                            <label>Referring Source</label>
                            <b-form-input v-model="agent.referring" placeholder="Enter Referral Source"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <b-button block @click="optIn" class="gold-button justify-content-center" :disabled="!submissionValid">Perform Opt In</b-button>
                    </b-col>
                    <b-col cols="6">
                        <b-button block @click="authenticate" class="gold-button justify-content-center" :disabled="!submissionValid">Authenticate</b-button>
                    </b-col>
                </b-row>
            </b-card>
        </b-collapse>
    </div>
</template>
<script>
import {isValidEmail} from '@helpers/email';

export default {
    emits:['authenticate'],
    name: 'AccessToken',
    props:{
        client:{
            type: Object,
            default:{
                uuid: null,
                secret: null
            }
        },
        agent:{
            type: Object,
            default:{
                email: null,
                firstName: null,
                lastName: null,
                phone: null,
                licenseId: null,
                licenseState: null,
                broker: null,
                referring: null
            }
        },
        states:{
            type:Array,
            default:[]
        },
        accessResponse:{
            type: Object
        }
    },
    data:()=>({
        validation:{
            agent:{
                email: null,
                firstName: null,
                lastName: null,
                licenseId: null,
                licenseState: null
            },
            client:{
                uuid: null,
                secret: null
            }
        }
    }),
    computed:{
        stateOptions(){
            
            return this.states;
        },
        accessTokenUrl(){
            return window.env.APP_URL+`/auth/partnerAccessToken`;
        },
        validEmail(){
            return isValidEmail(this.agent.email);
        },
        submissionValid(){
            Object.keys(this.validation).forEach(k => {
                Object.keys(this.validation[k]).forEach(p => {
                    if(this.validation[k][p] == false || this.validation[k][p] === null){
                        return false;
                    }
                });
            });
            return true;
        }
    },
    methods:{
        authenticate(){
            this.$emit('authenticate');
        },
        optIn(){
            this.$emit('opt-in');
        },
        validate(set, prop, value){
            console.log(value);
            if(prop == 'email'){
                this.validation.agent.email = !!value && isValidEmail(this.agent.email);
            }else{
                this.validation[set][prop] = !!value;
            }
            return this.submissionValid;
        }
    },
    mounted(){
        
    }
}
</script>
